import React, { useEffect, useState } from "react";
import { ServiceSection } from "../../AdminStyle.styled";
import { Row, Col, Button, Table, Modal } from "antd";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import {
  DeleteProduct,
  GetAllProducts,
  GetOneConfiguredServices,
  CreateOneProduct,
  UpdateOneProduct,
} from "../../../../../redux/actions/adminActions";
import { Delete, Edit, Add } from "@mui/icons-material";
import { formatDateObjectHandler, priceFormat } from "../../../../../utils";
import CreateProductModal from "./CreateProductModal";

const RawMaterials = (props) => {
  const {
    allProducts,
    CreateOneProduct,
    UpdateOneProduct,
    GetAllProducts,
    DeleteProduct,
    my_roles,
    user_details,
  } = props;

  const [deleteLoading, setDeleteLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [formMode, setFormMode] = useState("CREATE_MODE");
  const [productRecord, setProductRecord] = useState(null);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: allProducts?.length,
  });

  const editRecord = async (record) => {
    setProductRecord(record);
    setVisible(true);
    setFormMode("UPDATE_MODE");
  };

  const deleteRecord = (record) => {
    Modal.confirm({
      title: "Do you want to delete this record?",
      content: "Click yes to proceed",
      okText: "Delete",
      loading: deleteLoading,
      okType: "danger",
      async onOk() {
        setDeleteLoading(true);
        const res = await DeleteProduct(record.id);
        if (res.success) {
          setDeleteLoading(false);
          toast.success(res.message, {
            pauseOnHover: false,
          });
        } else {
          toast.info(res.message, {
            pauseOnHover: true,
          });
        }
      },
      onCancel() {
        setDeleteLoading(false);
        return false;
      },
    });
  };
  const CreateService = () => {
    setVisible(true);
    setFormMode("CREATE_MODE");
    setProductRecord(null);
  };

  const closeModal = () => {
    setVisible(false);
    setFormMode("CREATE_MODE");
    setProductRecord(null);
  };

  const privileges = my_roles[0]?.role?.privileges;

  const recordColumn = [
    {
      title: "Product ID",
      dataIndex: "id",
    },
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Price",
      dataIndex: "price",
      align: "center",
      render: (_text, record) => <>{priceFormat(record?.price)}</>,
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
    },
    {
      title: "Date Created",
      dataIndex: "date_created",
      align: "center",
      render: (_text, record) => (
        <>
          {formatDateObjectHandler(record.date_created, "Do MMM YYYY")} <br />
        </>
      ),
    },
    {
      title:
        user_details?.is_staff ||
        privileges?.includes("products.edit_product") ||
        privileges?.includes("products.delete_product")
          ? "action"
          : null,
      dataIndex: "action",
      align: "center",
      render: (_text, record) => (
        <>
          {user_details?.is_staff ||
          privileges?.includes("products.edit_product") ||
          privileges?.includes("products.delete_product") ? (
            <div className="actiontable">
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              {user_details?.is_staff ||
                (privileges?.includes("products.edit_product") && (
                  <button className="eid" onClick={() => editRecord(record)}>
                    <Edit />
                  </button>
                ))}
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              {(user_details?.is_staff ||
                privileges?.includes("products.delete_product")) && (
                <button className="del" onClick={() => deleteRecord(record)}>
                  <Delete />
                </button>
              )}
            </div>
          ) : null}
        </>
      ),
    },
  ];

  useEffect(() => {
    const getProductRecords = async () => {
      setLoading(true);
      const res = await GetAllProducts();
      setLoading(false);
      if (!res.success) {
        setLoading(false);
        toast.error(`Error`);
      }
    };
    getProductRecords();
  }, [GetAllProducts]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  return (
    <ServiceSection>
      {(user_details?.is_staff ||
        privileges?.includes("products.add_product")) && (
        <Row>
          <Col xs={24}>
            <div style={{ textAlign: "right", marginBottom: "15px" }}>
              <Button
                onClick={CreateService}
                icon={<Add style={{ marginRight: "8px" }} />}
                type="primary"
              >
                {" "}
                Create Product
              </Button>
            </div>
          </Col>
        </Row>
      )}

      <Table
        rowKey="id"
        style={{ overflowX: "auto" }}
        loading={loading}
        columns={recordColumn}
        dataSource={allProducts?.slice(
          (pagination.current - 1) * pagination.pageSize,
          pagination.current * pagination.pageSize
        )}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showSizeChanger: false,
          showQuickJumper: false,
        }}
        onChange={handleTableChange}
      />

      <CreateProductModal
        visible={visible}
        closeModal={closeModal}
        formMode={formMode}
        one_product={productRecord}
        CreateOneProduct={CreateOneProduct}
        UpdateOneProduct={UpdateOneProduct}
      />
    </ServiceSection>
  );
};

const mapStateToProps = (state) => {
  return {
    allProducts: state.adminReducer.allProducts,
    one_service: state.adminReducer.one_service,
    my_roles: state.userManagementReducer.my_roles,
    user_details: state.authReducer.user_details,
  };
};

export default connect(mapStateToProps, {
  GetAllProducts,
  CreateOneProduct,
  UpdateOneProduct,
  DeleteProduct,
  GetOneConfiguredServices,
})(RawMaterials);
